import { useEffect, useState } from 'react';

/**
 * Manages dish detail modal open/close state and listens for the global
 * `closeAllDishModals` event so that modals are dismissed when the
 * unsaved-changes modal is triggered.
 */
export const useDishDetailsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleCloseAllDishModals = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener('closeAllDishModals', handleCloseAllDishModals);

    return () => {
      window.removeEventListener('closeAllDishModals', handleCloseAllDishModals);
    };
  }, [isOpen]);

  return { isOpen, open, close };
};
